import { ServiceProvider } from '@quasarcast/vue-service'
import { OrionPlugin, useCreateResource, useFetchResources, useFetchResource } from '@vuemodel/orion-pinia-orm'
import { set } from 'lodash-es'
import { useRemoveResource, useUpdateResource } from 'src/packages/orion-pinia-orm/resource'

export const orionPiniaOrmServiceProvider: ServiceProvider = {
  /**
   * Register any services by adding them to app
   */
  setup: async ({ vueApp, config, app }) => {
    vueApp.use(OrionPlugin, config.orionPiniaOrm)

    set(app, 'orion.piniaOrm.useCreateResource', useCreateResource)
    set(app, 'orion.piniaOrm.useUpdateResource', useUpdateResource)
    set(app, 'orion.piniaOrm.useRemoveResource', useRemoveResource)
    set(app, 'orion.piniaOrm.useFetchResource', useFetchResource)
    set(app, 'orion.piniaOrm.useFetchResources', useFetchResources)
  },
}
